export default __webpack_public_path__ + "static/media/loader.ff2b6279.gif";